import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import CategoryPage from './pages/CategoryPage';
import SingleProductPage from './pages/SingleProductPage';
import RiaSkincare from './pages/RiaSkincare';
import SingleRiaProductPage from './pages/SingleRiaProductPage';
import { CartProvider } from './context/CartContext';
export function App() {
  return <CartProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-2">
          <Navbar data-id="element-3" />
          <main className="flex-grow" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
              <Route path="/products" element={<Products data-id="element-9" />} data-id="element-8" />
              <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
              <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
              <Route path="/cart" element={<Cart data-id="element-15" />} data-id="element-14" />
              <Route path="/blog" element={<Blog data-id="element-17" />} data-id="element-16" />
              <Route path="/blog/:slug" element={<BlogPost data-id="element-19" />} data-id="element-18" />
              <Route path="/category/:category" element={<CategoryPage data-id="element-21" />} data-id="element-20" />
              <Route path="/product/:productId" element={<SingleProductPage data-id="element-23" />} data-id="element-22" />
              <Route path="/ria-skincare" element={<RiaSkincare data-id="element-25" />} data-id="element-24" />
              <Route path="/ria-skincare/product/:productId" element={<SingleRiaProductPage data-id="element-27" />} data-id="element-26" />
            </Routes>
          </main>
          <Footer data-id="element-28" />
        </div>
      </Router>
    </CartProvider>;
}